import { Typography } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

import { useBackOfficeDeviceCameraSamplePoint } from 'store/modules/backOfficeDevice/hooks';
import { selectRouterQueryStringSelectedDevice } from 'store/modules/routerUtils/selectors';

import CameraDataUsage from '../CameraDataUsage';
import CameraDetails from '../CameraDetails';

export default function BackOfficeDeviceCameraForm() {
  const deviceId = useSelector(selectRouterQueryStringSelectedDevice);
  const cameraSamplePoint = useBackOfficeDeviceCameraSamplePoint(deviceId);

  if (!cameraSamplePoint) return null;
  return (
    <>
      <Typography.Text strong style={{ fontSize: 16 }}>Camera</Typography.Text>
      <CameraDetails isBackOffice samplePoint={cameraSamplePoint} />
      <br />
      <CameraDataUsage isBackOffice samplePoint={cameraSamplePoint} />
    </>
  );
}
